import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OrderComplete.css";

const OrderComplete = () => {
  const navigate = useNavigate();
  const [showCheck, setShowCheck] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    // Delay checkmark
    setTimeout(() => setShowCheck(true), 300);

    // 🎊 Confetti effect (blue + white palette)
    const duration = 2500;
    const animationEnd = Date.now() + duration;
    const randomInRange = (min, max) => Math.random() * (max - min) + min;

    (function frame() {
      if (window.confetti) {
        window.confetti({
          particleCount: 4,
          startVelocity: 35,
          spread: 360,
          ticks: 60,
          origin: {
            x: randomInRange(0.2, 0.8),
            y: randomInRange(0.1, 0.3),
          },
          colors: ["#007bff", "#66b2ff", "#ffffff", "#e6f0ff"], // 💙 on-brand palette
        });
      }
      if (Date.now() < animationEnd) requestAnimationFrame(frame);
    })();

    // Show thank-you message
    setTimeout(() => setShowMessage(true), 2500);
  }, []);

  return (
    <div className="order-complete">
      <div className="order-box">
        <div className={`checkmark ${showCheck ? "animate" : ""}`}>
          <svg
            viewBox="0 0 52 52"
            className="checkmark-svg"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle className="checkmark-circle" cx="26" cy="26" r="25" />
            <path
              className="checkmark-check"
              fill="none"
              d="M14 27l7 7 16-16"
            />
          </svg>
        </div>

        <h1>🎉 Order Complete!</h1>
        <p>
          Thank you for your purchase. Your order has been successfully placed.
        </p>

        <button onClick={() => navigate("/")} className="back-home">
          Back to Home
        </button>

        {showMessage && (
          <p className="thankyou-note">
            We’ll email your receipt and shipping details shortly. 📦
          </p>
        )}
      </div>
    </div>
  );
};

export default OrderComplete;
